'use strict';

/* globals google */
var baseStoreLocator = require('base/storeLocator/storeLocator');
var googleMap;

var isStoreLP = function () {
    return $('.js_find-store').length > 0;
};

var setAutocompleteCountry = function (countryCode) {
    $(document).trigger('custom:change:autocomplete:country', { countryCode: countryCode });
};
/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl +=
        (newUrl.indexOf('?') !== -1 ? '&' : '?') +
        Object.keys(params)
            .map(function (key) {
                return key + '=' + encodeURIComponent(params[key]);
            })
            .join('&');

    return newUrl;
}

var clearFormAfterSearch = function () {
    var $form = $('.js-store-locator');
    $form.find('[name="_postalCode"]').val('');
    $form
        .find('[name="postalCode"]')
        .val('')
        .trigger('change');
    $form.find('[name="_lat"]').val('');
    $form.find('[name="_lng"]').val('');
};

var centerMapOnLocation = function (lat, lng, zoom) {
    if (!googleMap) {
        return;
    }

    googleMap.setCenter(new google.maps.LatLng({ lat: lat, lng: lng }));

    if (typeof zoom === 'number') {
        googleMap.setZoom(zoom);
    }
};

/**
 * Uses google maps api to render a map
 */
function maps() {
    var $canvas = $('.map-canvas');
    var infowindow = new google.maps.InfoWindow();

    // Init U.S. Map in the center of the viewport
    var $currentLocation = $('.js_current-location');
    var lat = $currentLocation.data('latitude');
    var lng = $currentLocation.data('longitude');
    var latlng = new google.maps.LatLng(lat, lng);
    var mapOptions = {
        scrollwheel: false,
        zoom: 10,
        center: latlng
    };

    googleMap = new google.maps.Map($canvas[0], mapOptions);
    var mapdiv = $canvas.attr('data-locations');

    mapdiv = JSON.parse(mapdiv);

    var markerImg = $canvas.data('google-marker');

    mapdiv.forEach(function (item) {
        var storeID = $(item.infoWindowHtml).data('store-id');
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: googleMap,
            title: item.name,
            icon: markerImg
        });

        marker.addListener('click', function (data) {
            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.open(googleMap, marker);

            if (!(data && data.event === 'virtual')) {
                $('.js_store-wrapper[data-store-id="' + storeID + '"]')
                    .eq(0)
                    .trigger('click', { event: 'virtual' });
            }
        });

        $(document).on('custom:marker:click', function (e, data) {
            if (data.storeID === storeID) {
                google.maps.event.trigger(marker, 'click', { event: 'virtual' });
            }
        });
    });
}

var toggleMapImageAccordingStores = function () {
    var $container = $('.js_find-store');

    if ($container.hasClass('detecting-location')) {
        $container.removeClass('no-stores detecting-location');
    } else {
        $container.toggleClass('no-stores', $('.js_store-locator-no-results').length !== 0);
    }
};

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    $('.js_store-locator-results')
        .data('search-key', data.searchKey)
        .html(data.storesResultsHtml);
}

/**
 * render store via ajax call
 * @param {string} url - the target url
 */
function ajaxStoreCall(url) {
    $.spinner().start();

    $.ajax({
        url: url,
        type: 'GET',
        dataType: 'json',
        success: function (data) {
            updateStoresResults(data);
            clearFormAfterSearch();
            toggleMapImageAccordingStores();
        },
        complete: function () {
            $.spinner().stop();
        }
    });
}

/**
 * load stores
 */
function loadAllStores() {
    $('.js_find-store')
        .removeClass('show-map-mobile')
        .addClass('all-stores');

    var $btn = $('.js-load-stores');
    var lat = $btn.data('latitude');
    var lng = $btn.data('longitude');
    var params = {
        radius: 13000,
        countryCode: $('.js-store-locator [name="countryCode"]').val(),
        latitude: lat,
        longitude: lng
    };

    setTimeout(function () {
        centerMapOnLocation(lat, lng, 10);
    }, 100);

    var url = appendToUrl($btn.data('action'), params);
    ajaxStoreCall(url);
}

var geoEnabled = function (position) {
    $('.map-canvas, .js_store-form-bottom-toggle-links').removeClass('d-none');
    $('.store-banner-content').addClass('d-none');
    $('.js-detect-location').prop('disabled', false);
    $('.js_current-location')
        .data('longitude', position.coords.longitude)
        .data('latitude', position.coords.latitude);
};

var geoDisabled = function (error) {
    if (error.code) {
        $('.js-detect-location').prop('disabled', true);
        loadAllStores();
    }
};

var checkGeolocationOnPageLoad = function () {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(geoEnabled, geoDisabled);
    } else {
        window.console.warn('Geolocation is not supported by this browser.');
        geoDisabled({ code: true });
    }
};

/**
 * Search for stores with new zip code
 */
function search() {
    $.spinner().start();
    var $form = $('.js-store-locator');
    var lat = parseFloat($form.find('[name="_lat"]').val());
    var lng = parseFloat($form.find('[name="_lng"]').val());
    var radius = 300;
    var url = $form.data('action');
    var urlParams = {
        radius: radius,
        postalCode: $form.find('[name="_postalCode"]').val() || $form.find('[name="postalCode"]').val(),
        countryCode: $form.find('[name="countryCode"]').val(),
        latitude: lat,
        longitude: lng
    };

    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: 'GET',
        dataType: 'json',
        success: function (data) {
            $('.js_find-store').removeClass('all-stores');
            updateStoresResults(data);

            if (data && data.stores && data.stores.length > 0) {
                lat = lat || data.stores[0].latitude;
                lng = lng || data.stores[0].longitude;
            }

            setTimeout(function () {
                centerMapOnLocation(lat, lng, 10);
            }, 100);
            clearFormAfterSearch();
            toggleMapImageAccordingStores();
        },
        complete: function () {
            $.spinner().stop();
        }
    });
}

var toggleStoreHours = function () {
    $(document).on('click', '.js_store-hours-title', function () {
        $(this)
            .closest('.js_store-hours-container')
            .toggleClass('show-hours')
            .find('.js_store-hours')
            .slideToggle();
    });
};

var toggleSelectStore = function () {
    $(document).on('click', '.js_store-wrapper', function (e, data) {
        if ($(e.target).hasClass('js_store-hours-title') || $(e.target).hasClass('store-name')) {
            return;
        }

        var storeID = $(this).data('store-id');

        if ($(this).hasClass('selected')) {
            $('.js_store-wrapper[data-store-id="' + storeID + '"]').removeClass('selected');
        } else {
            $('.js_store-wrapper').removeClass('selected');
            $('.js_store-wrapper[data-store-id="' + storeID + '"]').addClass('selected');
            $('.js_store-locator-results').animate({ scrollTop: 0 }, 500);

            if (!(data && data.event === 'virtual')) {
                $(document).trigger('custom:marker:click', { storeID: storeID });
            }
        }

        var lat = $(this).data('store-latitude');
        var lng = $(this).data('store-longitude');
        setTimeout(function () {
            centerMapOnLocation(lat, lng, 10);
        }, 100);
    });
};

var changeAutocompleteCountryEvent = function () {
    $(document).on('change', '#countryCode', function () {
        var countryCode = $(this).val() || 'US';

        setAutocompleteCountry(countryCode);
    });
};

var toggleShowingMapMobile = function () {
    $(document)
        .on('click', '.js_show-list', function () {
            $(this).addClass('active');
            $('.js_show-map').removeClass('active');
            $('.js_find-store').removeClass('show-map-mobile');
        })
        .on('click', '.js_show-map', function () {
            $(this).addClass('active');
            $('.js_show-list').removeClass('active');
            $('.js_find-store').addClass('show-map-mobile');
        });
};

module.exports = {
    init: function () {
        $(document).on('blur change', '[name="postalCode"]', function () {
            $('.js_btn-storelocator-search').prop('disabled', $(this).val() === '');
        });

        $(window).on('load', function () {
            if (isStoreLP()) {
                checkGeolocationOnPageLoad();
            }

            if ($('.map-canvas').data('has-google-api')) {
                maps();
            } else {
                $('.store-locator-no-apiKey').show();
            }
        });

        toggleStoreHours();

        if (isStoreLP()) {
            // Store landing page
            toggleSelectStore();
            changeAutocompleteCountryEvent();
            $('#countryCode').trigger('change');
            toggleShowingMapMobile();
        }
    },

    detectLocation: function () {
        // clicking on detect location
        $('.js-detect-location').on('click', function () {
            var $this = $(this);

            if ($this.is(':disabled')) {
                return;
            }

            $('.js_find-store')
                .removeClass('all-stores')
                .addClass('detecting-location');

            var $currentLocation = $('.js_current-location');
            var lat = $currentLocation.data('latitude');
            var lng = $currentLocation.data('longitude');
            setTimeout(function () {
                centerMapOnLocation(lat, lng, 10);
            }, 100);

            // fetch the parameters stored in data attribute
            var urlParams = {
                longitude: lng,
                latitude: lat,
                radius: 300
            };

            var url = appendToUrl($this.data('action'), urlParams);
            ajaxStoreCall(url);
        });
    },

    loadAllStores: function () {
        $('.js-load-stores').on('click', loadAllStores);
    },

    search: function () {
        $('.js_btn-storelocator-search').click(function (e) {
            e.preventDefault();
            search();
        });
    },

    selectStore: baseStoreLocator.selectStore,

    updateSelectStoreButton: baseStoreLocator.updateSelectStoreButton
};
